"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropList = void 0;
var _react = require("react");
var _DropList = require("./DropList.styles");
var _List = require("../../../../Data/List");
var _jsxRuntime = require("react/jsx-runtime");
const DropList = props => {
  const {
    options,
    additionalOptions,
    selectedOptions,
    isMultiSelect,
    onSelectOption,
    optionSize = 'small',
    additionalOptionsBtnLabel,
    id
  } = props;
  const styles = (0, _DropList.useStyles)(props);
  const anyAdditionalOptionSelected = additionalOptions && additionalOptions.length > 0 && selectedOptions.length > 0 ? additionalOptions.filter(o => selectedOptions.includes(o)).length > 0 : false;
  const [isAdditionalOptionsVisible, setIsAdditionalOptionsVisible] = (0, _react.useState)(anyAdditionalOptionSelected);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Select__dropList'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_List.List, {
      role: "listbox",
      id: id,
      isMultiSelect: isMultiSelect,
      children: [options.map(option => {
        const args = option.isSeparator ? {
          isSeparator: true,
          role: 'title',
          isSelected: false,
          isWithCheckbox: false,
          onClick: undefined
        } : {
          role: 'option',
          isSelected: Boolean(selectedOptions.find(op => op?.value === option.value)),
          isWithCheckbox: isMultiSelect,
          onClick: () => {
            onSelectOption(option);
          }
        };
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
          className: option.className,
          id: option.value.toString(),
          color: "basic",
          size: optionSize,
          isDisabled: option.isDisabled,
          ...args,
          children: option.label
        }, option.value.toString());
      }), additionalOptions && additionalOptions.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
          id: "extra_options_seperator",
          isSelected: false,
          isWithCheckbox: false,
          onClick: undefined,
          size: optionSize,
          role: "title",
          color: "basic",
          isSeparator: true
        }), !isAdditionalOptionsVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
          id: "show_extra_options_button",
          isSelected: false,
          isWithCheckbox: false,
          onClick: () => {
            setIsAdditionalOptionsVisible(true);
          },
          size: optionSize,
          role: "title",
          color: "basic",
          children: additionalOptionsBtnLabel
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: additionalOptions.map(additionalOption => {
            const args = additionalOption.isSeparator ? {
              isSeparator: true,
              role: 'title',
              isSelected: false,
              isWithCheckbox: false,
              onClick: undefined
            } : {
              role: 'option',
              isSelected: Boolean(selectedOptions.find(op => op?.value === additionalOption.value)),
              isWithCheckbox: isMultiSelect,
              onClick: () => {
                onSelectOption(additionalOption);
              }
            };
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
              className: additionalOption.className,
              id: additionalOption.value.toString(),
              color: "basic",
              size: optionSize,
              isDisabled: additionalOption.isDisabled,
              ...args,
              children: additionalOption.label
            }, additionalOption.value.toString());
          })
        })]
      })]
    })
  });
};
exports.DropList = DropList;